import ApplicationAdapter from 'eflex/adapters/application';

export default class TaskAdapter extends ApplicationAdapter {
  namespace = 'locations';
}
